import { safeParse } from '../../utils/general/general';
import reportApiError from './reportApiError/reportApiError';

const tomTomApiCall = (
  verb: 'GET' | 'POST' | 'PUT' | 'DELETE',
  path: string,
  data?: URLSearchParams | FormData | object | string,
  signal?: AbortSignal,
) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    const server = 'https://api.tomtom.com';

    let url = [server, path].join('/');

    if (data instanceof URLSearchParams) url = [url, data].join('?');

    xhr.open(verb, url, true);
    xhr.timeout = 10_000;

    signal?.addEventListener('abort', () => {
      xhr.abort();
    });

    if (!data || data instanceof URLSearchParams) {
      xhr.send();
    } else if (data instanceof FormData) {
      xhr.send(data);
    } else if (typeof data === 'string') {
      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
      xhr.send(data);
    } else {
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(data));
    }

    /* v8 ignore next 9 -- @preserve */
    xhr.onload = () => {
      const json = safeParse(xhr.responseText);
      if (xhr.status < 200 || xhr.status >= 300) {
        reportApiError({
          service: 'tomtom',
          method: verb,
          path,
          status: xhr.status,
          failureType: 'http_error',
          responseBody: json,
        });
        // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
        reject(json);
      }
      resolve(json);
    };

    /* v8 ignore next -- @preserve */
    // Aborts are intentional (search debounce cancellations) — not reported.
    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
    xhr.onabort = () => reject({ error: 'Request aborted', status: xhr.status });
    /* v8 ignore next 4 -- @preserve */
    /* istanbul ignore next */
    xhr.ontimeout = () => {
      reportApiError({
        service: 'tomtom',
        method: verb,
        path,
        status: xhr.status,
        failureType: 'timeout',
      });
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      reject({ error: 'Request timeout', status: xhr.status });
    };
    /* v8 ignore next 4 -- @preserve */
    xhr.onerror = () => {
      reportApiError({
        service: 'tomtom',
        method: verb,
        path,
        status: xhr.status,
        failureType: 'network_error',
      });
      // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
      reject({ error: 'Request could not send', status: xhr.status });
    };
  });
};

export default tomTomApiCall;
